var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43721 11.0559C5.40022 11.2107 5.32084 11.3521 5.20802 11.4642C5.01122 11.6627 4.73579 11.762 4.45792 11.7347C4.01163 11.7659 3.60396 11.4811 3.47862 11.0507L0.540736 8.10792C0.211542 7.73605 0.228228 7.17152 0.578808 6.81983C0.929389 6.46815 1.49257 6.45098 1.86383 6.78066L4.13496 9.06133L8.7814 0.804327C8.91619 0.557117 9.14491 0.374983 9.41563 0.299278C9.68635 0.223573 9.9761 0.26072 10.2191 0.402284C10.722 0.713291 10.8879 1.36813 10.5941 1.88201L5.43721 11.0559Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1c8b15f5fa9b472da1a649753b3f72ee.svg";
export { ForwardRef as ReactComponent };